import { Injectable } from '@angular/core';
import { COLS, ROWS, emptyFrame, Frame } from '../models/led-board.model';
import { FitMode, fitRect, rgbaToFrame } from '../models/led-image.util';

@Injectable({ providedIn: 'root' })
export class ImageImportService {
  fileToImage(file: File): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('Could not read file'));
      reader.onload = () => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Could not load image'));
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  imageToFrame(img: HTMLImageElement, mode: FitMode, crop: { x: number; y: number } = { x: 0, y: 0 }): Frame {
    const canvas = document.createElement('canvas');
    canvas.width = COLS; canvas.height = ROWS;
    const ctx = canvas.getContext('2d');
    if (!ctx) { return emptyFrame(); }
    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, COLS, ROWS);
    const w = img.naturalWidth || img.width;
    const h = img.naturalHeight || img.height;
    const r = fitRect(mode, w, h, crop.x, crop.y);
    ctx.drawImage(img, r.dx, r.dy, r.dw, r.dh);
    return rgbaToFrame(ctx.getImageData(0, 0, COLS, ROWS).data);
  }
}
